import { frontDoorPath } from "../../coworlds/creator-rooms";
import {
  buildHref,
  matchRoute,
  type GameDestinationContext,
} from "@softmax/web-addresses";

type CoworldRoom = "wiki" | "forum" | "play" | "preview";
type SwitchTarget = {
  readonly corpusSlug: string;
  readonly route: GameDestinationContext;
};

function roomOf(pathname: string): CoworldRoom {
  const route = matchRoute(pathname);

  if (route.area !== "game") return "preview";

  switch (route.section) {
    case "wiki":
    case "forum":
      return route.section;
    case "play":
      if (
        route.league &&
        (route.name === "game.playEpisodes" ||
          route.name === "game.playRequests" ||
          route.name === "game.playActivity")
      )
        return "preview";

      return "play";
    default:
      return "preview";
  }
}

export function switchCoworldHref({
  pathname,
  target,
}: {
  readonly pathname: string;
  readonly target: SwitchTarget;
}): string {
  const route = { game: target.route.game };
  const room = roomOf(pathname);

  if (room === "preview")
    return frontDoorPath({ corpusSlug: target.corpusSlug, route });

  return buildHref({ name: `game.${room}`, ...route });
}

export function switchLeagueHref({
  pathname,
  target,
}: {
  readonly pathname: string;
  readonly target: SwitchTarget;
}): string {
  if (roomOf(pathname) === "play")
    return buildHref({ name: "game.play", ...target.route });

  return frontDoorPath(target);
}
